import { render, staticRenderFns } from "./function_life_record.vue?vue&type=template&id=2168c762&scoped=true"
import script from "./function_life_record.vue?vue&type=script&lang=js"
export * from "./function_life_record.vue?vue&type=script&lang=js"
import style0 from "./function_life_record.vue?vue&type=style&index=0&id=2168c762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2168c762",
  null
  
)

export default component.exports